export default {
  title: 'Log ind på din egen adresse',
  description:
    'Denne adresse tilhører en partner, som din konto ikke er en del af. For at beskytte din konto skal du logge ind, hvor du plejer – din e-mail og adgangskode virker der.',
  continue: 'Fortsæt til {{host}}',
  password_changed: 'Din adgangskode blev ændret.',
};
